var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Guid } from "../../../utilities/guid";
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
var CheckBox = /** @class */ (function () {
    function CheckBox(element) {
        var _this = this;
        this.element = element;
        this.identifier = Guid.generateGuid();
        this.onKeyDown = function (event) {
            var code = event.keyCode;
            if (code === 32) {
                _this.onClick(event);
                event.preventDefault();
            }
        };
    }
    CheckBox.prototype.attached = function () {
        // disableds TabIndex when Disabled or Readonly
        if (this.disableInput || this.disabled || this.readonly) {
            this.tab = -1;
        }
        if (this.label) {
            this.label.addEventListener("keydown", this.onKeyDown, false);
        }
    };
    CheckBox.prototype.detached = function () {
        if (this.label) {
            this.label.removeEventListener("keydown", this.onKeyDown, false);
        }
    };
    CheckBox.prototype.onClick = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var canCall;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($event) {
                            $event.stopPropagation();
                        }
                        canCall = true;
                        if (!this.beforeOnClick) return [3 /*break*/, 2];
                        if (this.readonly || this.disabled || this.disableInput) {
                            return [2 /*return*/];
                        } // no action take place when disabled and read only
                        return [4 /*yield*/, this.beforeOnClick()];
                    case 1:
                        canCall = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (canCall) {
                            setTimeout(function () {
                                _this.check();
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckBox.prototype.disabledChanged = function () {
        if (this.disabled) {
            this.tab = -1;
        }
        else {
            this.tab = 0;
        }
    };
    CheckBox.prototype.check = function () {
        var _this = this;
        if (this.readonly || this.disabled || this.disableInput) {
            return;
        }
        this.checked = !this.checked;
        setTimeout(function () {
            var changeEvent = new CustomEvent("changed", {
                detail: {
                    value: _this.checked
                },
                bubbles: true
            });
            _this.element.dispatchEvent(changeEvent);
        });
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], CheckBox.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], CheckBox.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CheckBox.prototype, "checked", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CheckBox.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CheckBox.prototype, "disableInput", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CheckBox.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], CheckBox.prototype, "tab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], CheckBox.prototype, "beforeOnClick", void 0);
    CheckBox = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], CheckBox);
    return CheckBox;
}());
export { CheckBox };
